import { createAction, props } from '@ngrx/store';

export const setWord = createAction(
    '[Search] Set Word',
    props<{word: string}>()
);
